var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialprowhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 23,
    viewBox: "0 0 30 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.000210938 2.72516C0.000210938 5.07516 0.800211 6.22516 4.00021 8.32516C7.55021 10.6752 8.00021 11.4252 8.00021 14.9252C8.00021 19.8252 9.50021 22.7252 12.0502 22.7252C13.8002 22.7252 14.0002 22.0252 14.0002 14.9752L13.9502 7.22516L7.55021 3.47516C-0.149789 -1.02484 0.000210938 -1.02484 0.000210938 2.72516Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2502 3.52516L16.0502 7.22516L16.0002 14.9752C16.0002 22.0252 16.2002 22.7252 17.9502 22.7252C20.5002 22.7252 22.0002 19.8252 22.0002 14.9252C22.0002 11.4252 22.4502 10.6752 26.0002 8.32516C29.2002 6.22516 30.0002 5.07516 30.0002 2.72516C30.0002 -1.02484 29.8502 -0.974842 22.2502 3.52516Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialprowhite);
export default __webpack_public_path__ + "static/media/materialprowhite.827ad48a3e5b1f385f2f3c32e6823127.svg";
export { ForwardRef as ReactComponent };